// CEO 2026-11-01 · Chaque info au bon endroit (miroir de backend/services/onboarding_validators.py).
const EMAIL = /^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/;
const URL_RE = /https?:\/\/|www\./i;
const LETTER = /[A-Za-zÀ-ÿ]/;
const DIGIT = /\d/;
const SSN = /^[1278]\d{4}(\d{2}|2A|2B)\d{6}(\d{2})?$/i;

const contact = (v) => v.includes("@") || URL_RE.test(v);

const RULES = {
    last_name: (v) => (contact(v) || DIGIT.test(v) ? "Uniquement des lettres (pas d'email, de chiffres ni de lien)." : null),
    address_line1: (v) => {
        if (contact(v)) return "C'est un email/lien : indiquez le n° et le nom de la rue (l'email va dans « Email »).";
        if (v.length < 5 || !LETTER.test(v)) return "Indiquez le n° et le nom de la rue (ex. 12 rue des Lilas).";
        if (/^\+?[\d\s.\-()]{8,}$/.test(v)) return "C'est un numéro de téléphone : indiquez votre adresse postale.";
        return null;
    },
    address_city: (v) => (contact(v) || DIGIT.test(v) || !LETTER.test(v) ? "Indiquez uniquement le nom de la ville (le code postal a son propre champ)." : null),
    address_postal_code: (v) => (/^\d{5}$/.test(v.replace(/\s/g, "")) ? null : "Code postal : 5 chiffres (ex. 33800)."),
    email: (v) => (EMAIL.test(v) ? null : "Adresse email invalide (ex. prenom.nom@gmail.com)."),
    phone_mobile: (v) => {
        const digits = v.replace(/\D/g, "");
        return LETTER.test(v) || v.includes("@") || digits.length < 9 || digits.length > 15 ? "Numéro de téléphone invalide (ex. 06 12 34 56 78)." : null;
    },
    social_security_number: (v) => (SSN.test(v.replace(/\s/g, "")) ? null : "N° de sécurité sociale : 15 chiffres (ou 13 sans la clé)."),
};
RULES.first_name = RULES.last_name;
RULES.maiden_name = RULES.last_name;
RULES.birth_city = RULES.address_city;

export function fieldErrors(data) {
    const out = {};
    Object.entries(RULES).forEach(([key, rule]) => {
        const raw = data?.[key];
        if (raw === undefined || raw === null || String(raw).trim() === "") return;
        const msg = rule(String(raw).trim());
        if (msg) out[key] = msg;
    });
    return out;
}
